// components/VisitsListKG.jsx
import React from 'react';
import { useVisits } from '../hooks/useVisits';
import { DeclineVisitModal } from './DeclineVisitModal';

const TABLE_CONFIG = {
  title: 'Календар прийому батьків',
  description: '',
  columns: [
    { title: '№', field: 'idx' },
    { title: 'Дата', field: 'date' },
    { title: 'Тема', field: 'topic' },
    { title: 'Ім\'я', field: 'name' },
    { title: 'Контактний телефон', field: 'phone' },
    { title: 'Статус', field: 'status' }
  ],
  emptyMessage: 'Не має записів на прийом в наближчі 10 днів'
};

export const VisitsListKG = ({ idKg }) => {
  const {
    visits,
    loading,
    error,
    selectedVisitIndex,
    setSelectedVisitIndex,
    updateVisitStatus
  } = useVisits(idKg);

  const handleRowClick = (index) => {
    setSelectedVisitIndex(index);
  };

  const handleModalClose = () => {
    setSelectedVisitIndex(-1);
  };

  const handleModalSave = async (value, text) => {
    await updateVisitStatus(value, text);
  };

  if (loading && visits.length === 0) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Завантаження...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid p-0">
      <div className="mb-4">
        <h3 className="h4 mb-2">{TABLE_CONFIG.title}</h3>
        <p className="text-muted mb-0">{TABLE_CONFIG.description}</p>
      </div>

      {error && (
        <div className="alert alert-danger" role="alert">
          {error}
        </div>
      )}

      <div className="table-responsive">
        <table className="table table-striped table-hover">
          <thead>
            <tr>
              {TABLE_CONFIG.columns.map((col, index) => (
                <th key={index} scope="col">
                  {col.title}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {visits.length > 0 ? (
              visits.map((row, index) => (
                <tr
                  key={index}
                  onClick={() => handleRowClick(index)}
                  style={{ cursor: 'pointer' }}
                >
                  {TABLE_CONFIG.columns.map((col, colIndex) => (
                    <td key={colIndex}>{row[col.field]}</td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={TABLE_CONFIG.columns.length} className="text-center py-4 fst-italic text-muted">
                  {TABLE_CONFIG.emptyMessage}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <DeclineVisitModal
        show={selectedVisitIndex >= 0}
        onClose={handleModalClose}
        onSave={handleModalSave}
      />
    </div>
  );
};